/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { NoFieldEditorAvailable } from "cms/fields/layout/empty/no-editor-available";
import { getFieldByType } from "cms/fields/field-utils";
import { DynamicFieldProvider } from "cms/fields/dynamic-field/context/dynamic-field-provider";
import { isUneditableField } from "cms/fields/dynamic-field/is-uneditable-field";
import { Logger } from "cms/utils/log/logger";

/**
 * @param {object} props
 * @param {string} props.type
 * @param {string} props.name
 * @param {number} props.position
 */
const DynamicField = (props) => {
    const type = props?.type;
    const name = props?.name;
    const position = props?.position;
    
    Logger.debug(`Field [name:${name}] [type:${type}]`, { props });
    if (!type) {
        Logger.warn(`DynamicField called with type of -> ${type}`);
        return <></>;
    }
    const FieldImplComponent = getFieldByType(type);
    if (!FieldImplComponent) {
        Logger.warn("DynamicField could not load a field by type.");
        return <></>;
    }

    // title and description and banner-image are not edited like the other fields
    if (isUneditableField(name)) {
        return <></>;
    }

    // All fields are edited this way
    if (FieldImplComponent) {
        return  (
            <DynamicFieldProvider position={position}>
                <FieldImplComponent />
            </DynamicFieldProvider>
        );
    }

    // No Editor available for field type
    const field = {
        type,
        name
    };

    return <NoFieldEditorAvailable field={field} />;
};
export { DynamicField };
